import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function BuyerProfile() {
  const navigate = useNavigate();
  return (
    <div className="space-y-4">
      <Button
        variant="ghost"
        onClick={() => navigate('/buyer/dashboard')}
        className="flex items-center gap-2"
      >
        <ArrowLeft className="h-4 w-4" />
        Back to Dashboard
      </Button>
      <RoleProfileEditor role="buyer" />
    </div>
  );
}